import template	from "./dialog-offgascalculation.html";
import css		from "./dialog-offgascalculation.css";

import Dialog	from "dialog";


class OffgascalculationDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-offgascalculation", OffgascalculationDialog);
  }
  constructor() {
    super();

	this.textboxRQ.value = application.devices.co2Sensor.value/application.devices.o2Sensor.value;
    this.show();
  }
  buttonClose_click() {
    this.close();
  }
}

OffgascalculationDialog.constructor();

export default OffgascalculationDialog;